<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  > 
    <CDropdownItem @click="logout()">
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>

export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return { 
      itemsCount: 42,
    }
  },
  methods:{
    logout(){
      this.$api.auth.logout().then((res) => {
        this.$cookies.remove(this.$apiTokenName);
        this.$router.push({ path: '/login' });
      }).catch((error) => {
        console.log(error);
      });
      //axios.post(this.$apiAdress + '/api/logout?token=' + localStorage.getItem("api_token"),{})
      //.then(function (response) {
      //  localStorage.setItem('roles', '');
      //  self.$router.push({ path: '/login' });
      //}).catch(function (error) {
      //  console.log(error); 
      //});
    }
  }
}
</script>
<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
